module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-14.ef86cf82.mp3";